var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16.4389 13.1521",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.369244 13.1266C0.256865 13.0981 0.0899029 12.9552 0.0449514 12.844C0.00963245 12.7583 0 12.4376 0 11.1643V9.59255H1.41276H2.82552V11.3707V13.1489L1.6311 13.1457C0.972878 13.1425 0.404563 13.133 0.369244 13.1266Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.82133 6.5756V0.00275213H8.22015H12.619V6.5756V13.1485H8.22015H3.82133V6.5756ZM7.22159 8.84911C7.66468 8.62684 10.4966 6.97251 10.5705 6.89313C10.7278 6.72484 10.7278 6.42636 10.5705 6.25807C10.4966 6.17869 7.66468 4.52436 7.22159 4.30209C7.13811 4.26082 7.02573 4.22589 6.97114 4.22589C6.75281 4.22589 6.56016 4.3656 6.48952 4.57199C6.43815 4.72441 6.43815 8.42679 6.48952 8.57921C6.59548 8.89039 6.91014 9.0047 7.22159 8.84911Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.6134 11.3707V9.59255H15.0262H16.4389V11.1643C16.4389 12.9107 16.4421 12.879 16.227 13.0409L16.1082 13.133L14.8592 13.1425L13.6134 13.1521V11.3707Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0 6.57595V4.54377H1.41276H2.82552V6.57595V8.60814H1.41276H0V6.57595Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.6134 6.57595V4.54377H15.0262H16.4389V6.57595V8.60814H15.0262H13.6134V6.57595Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M2.6976e-06 1.98773C2.6976e-06 0.241322 -0.00320812 0.273075 0.211917 0.111135L0.330717 0.0190517L1.57972 0.00952587L2.82552 0V1.78134V3.5595H1.41276H2.6976e-06V1.98773Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M13.6134 1.78134V0L14.8592 0.00952587L16.1082 0.0190517L16.227 0.111135C16.4421 0.273075 16.4389 0.241322 16.4389 1.98773V3.5595H15.0262H13.6134V1.78134Z",
    fill: "var(--fill-0, white)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/videoIcon.bd07cd38a75b427c4d669a4243454789.svg";
export { ForwardRef as ReactComponent };